<template>
  <NumeraiModal
    v-if="model"
    ref="modal"
    :dialog="dialog"
    :button="button"
    title="Rename model"
    button-text="Rename"
    :fields="fields"
    disabled-tooltip="You cannot rename this model"
    :enabled-tooltip="enabledTooltipText"
    save-button-text="Rename Model"
    :disabled="fetching"
    :save-callback="save"
    @close="close"
  >
    <template v-slot:activator>
      <slot></slot>
    </template>
    <div class="pb-3">
      Changing name of
      <span class="text_weight_600 text_uppercase ">{{ model.name }}</span>
    </div>
    <input
      v-model="fields.name"
      class="numerai-input full-width"
      placeholder="New model name"
    />
    <span class="color-error">{{ msg }}</span>
  </NumeraiModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NumeraiModal from '@/components/shared/NumeraiModal'

const defaultFields = {
  name: '',
}
export default {
  components: {
    NumeraiModal,
  },
  props: {
    modelId: { type: String, default: null },
    model: { type: Object, default: () => null },
    dialog: { type: Boolean, default: false },
    button: { type: Boolean, default: true },
    onClose: { type: Function, default: null },
  },
  data() {
    return {
      fields: {
        ...defaultFields,
      },
      msg: '',
      fetching: false,
    }
  },
  computed: {
    ...mapGetters(['atModelLimit', 'modelsRemaining']),
    enabledTooltipText() {
      return 'You can add ' + this.modelsRemaining + ' more models'
    },
  },

  methods: {
    ...mapActions(['showSnackBar', 'fetchAccountInfo']),
    close() {
      this.fields = {
        ...defaultFields,
      }
      this.onClose && this.onClose()
    },
    async save() {
      this.fetching = true
      try {
        this.msg = ''
        await this.$client.renameModel(this.model.id, this.fields.name)

        await this.fetchAccountInfo()
        this.fields = {
          ...defaultFields,
        }
        this.$refs.modal.close()
        this.showSnackBar({
          msg: `Model has been renamed`,
        })
      } catch (e) {
        this.msg = e.message
      }
      this.fetching = false
    },
  },
}
</script>
